// Base
import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { EqualHeightElement } from "../EqualHeight/EqualHeightElement";

import styles from "./ProductBuyBox.scss";

const ProductBuyBoxSection = forwardRef((props, ref) => {
  const { name, variants, children, ...restProps } = props;

  let variantsString = variants;

  if (!variantsString) {
    variantsString = styles.section;
  }

  if (typeof variantsString !== "string") {
    variantsString = variantsString.join(" ");
  }

  return (
    <div ref={ref} className={variantsString} {...restProps}>
      <EqualHeightElement name={name}>{children}</EqualHeightElement>
    </div>
  );
});

ProductBuyBoxSection.displayName = "ProductBuyBox.Section";

ProductBuyBoxSection.propTypes = {
  name: PropTypes.string.isRequired,
  variants: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

ProductBuyBoxSection.defaultProps = {
  variants: "",
  children: undefined,
};

ProductBuyBoxSection.Variant = {
  small: styles.sectionSmall,
  nameCompact: styles.sectionNameCompact,
  descriptionCompact: styles.sectionDescriptionCompact,
};

export default ProductBuyBoxSection;
